import { yupResolver } from "@hookform/resolvers/yup"
import { useForm } from "react-hook-form"
import type { Resolver, FieldValues, UseFormProps } from "react-hook-form"

// get the exact type of the first argument of yupResolver
export type YupSchema<TFieldValues extends FieldValues> = Parameters<
    typeof yupResolver<TFieldValues>
>[0]

interface UseFormWithSchemaInput<TFieldValues extends FieldValues>
    extends Omit<UseFormProps<TFieldValues>, "resolver"> {
    readonly schema: YupSchema<TFieldValues>
}

export function useFormWithSchema<TFieldValues extends FieldValues>({
    schema,
    ...useFormProps
}: UseFormWithSchemaInput<TFieldValues>) {
    const createdYupResolver = yupResolver(schema)

    const resolver = yupSchemaIsResolver<TFieldValues>(createdYupResolver)
        ? createdYupResolver
        : undefined

    return useForm<TFieldValues>({
        // There is a github issue open about this but is not resolved at the moment
        // This allows us to have nice type safety in the Props of Form while still making use of yupResolver
        // https://github.com/orgs/react-hook-form/discussions/11597
        resolver,
        ...useFormProps,
    })
}
function yupSchemaIsResolver<TFieldValues extends FieldValues>(
    schema: unknown
): schema is Resolver<TFieldValues> {
    return !!schema
}
